<template>
	<div class="input-textarea-wrap">
		<base-item :title="title">
			<textarea
				:style="`width:${inputWidthSize}px; height:${inputHeightSize}px;`"
				:placeholder="tt(placeholder)"
				:disabled="isReadOnly"
				v-model="value"
			></textarea>
		</base-item>
	</div>
</template>

<script>
import BaseItem from '@/views/common/components/BaseItem.vue'

export default {
	name: 'InputTextArea',
	components: {
		BaseItem,
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		inputWidthSize: {
			type: Number,
			default: 500,
		},
		inputHeightSize: {
			type: Number,
			default: 60,
		},
		inputValue: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		isRequired: {
			type: Boolean,
			default: false,
		},
		isReadOnly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			value: this.inputValue ?? '',
		}
	},
}
</script>

<style lang="scss" scoped>
.input-textarea-wrap {
	textarea {
		width: calc(100% - 250px);
		border: 1px solid $FILE_BORDER;
		border-radius: 5px;
		padding: 10px;
		&:disabled {
			background-color: $GREY_1;
		}
	}
}
</style>
